import { chooseService } from '../utils';
import React, { useEffect, useState } from 'react';
import useIsMounted from './useIsMounted';

const {CONFIG} = window;


const useRunLiveVideo = (ref: React.RefObject<HTMLVideoElement>, streamName: string, videoTagId: string) => {
  const [status, setVideoStatus] = useState('init');
  const [lost, setLost] = useState('');
  const [speed, setSpeed] = useState('');
  const {useSsl, ServerAddress, emsPort} = CONFIG;
  const isMounted = useIsMounted();
  //@ts-ignore
  const EvoWsPlayer = window.EvoWsPlayer;

  const options = {useSsl, emsIp: ServerAddress, emsPort, streamName, videoTagId};

  useEffect(() => {
    let player: any;
    chooseService(
      () => {
        player = new EvoWsPlayer(options);

        player.play()

        player.registerEventListener((event: string, description: string) => {
          if (isMounted.current) {
            switch (event) {
              case 'playerstarted':
                setVideoStatus('play');
                break;
              case 'playerpause':
                setVideoStatus('pause');
                break;
              case 'playerstopped':
                setVideoStatus('stop');
                break;
              case 'playerfroze':
                setVideoStatus('froze');
                break;
              case 'playernodata':
                setVideoStatus('no-data');
                break;
              case 'rep-frameloss':
                setLost(description);
                break;
              case 'rep-estthroughput':
                setSpeed(description);
                break;
            }
          }
        });
      },
      () => {
        return () => {

        }
      }
    );
    return () => {
      chooseService(
        () => player.stop(),
        () => {
        }
      )
    }
  }, []);

  return {status, speed, lost}
};

export default useRunLiveVideo